import styled from 'styled-components'
import dsTheme from '../../constants/design-system/theme.json'
import { progressiveBreakpoints } from '../../constants/theme'
import bgDesktop from '../../static/images/dotted-hero-desktop.svg'
import bgMobile from '../../static/images/dotted-hero-mobile.svg'

const { colors } = dsTheme

const HeroWrapper = styled.div`
  background-image: url('${bgMobile}');
  background-repeat: no-repeat;
  background-size: 100%;
  position: relative;
  z-index: 2;
  overflow: hidden;
  text-align: center;
  margin: 0 -1.5rem;
  padding: 4.68rem 1.5rem 35px;

  @media ${progressiveBreakpoints.tablet} {
    padding-top: 10rem;
  }

  @media ${progressiveBreakpoints.desktopSmall} {
    background-color: ${colors['UI/DarkGrey']};
    background-image: url('${bgDesktop}');
    background-size: cover;
    text-align: left;
    margin: 0;
    padding: 2.5rem;
    display: flex;
    flex-direction: column;
  }

  h1 {
    line-height: 1.12;
    margin-bottom: 1.5rem;

    @media ${progressiveBreakpoints.desktopSmall} {
      max-width: 484px;
      margin-bottom: 3rem;
    }
  }

  a {
    max-width: 272px;
    margin: 0 auto 1rem;
  }
`

const AwardImage = styled.img`
  max-width: 140px;
  display: block;
  margin: 0 auto;

  @media ${progressiveBreakpoints.desktopSmall} {
    margin: 0 -1.25rem -1.25rem auto;
  }
`

export { HeroWrapper, AwardImage }
